import { render } from "./AnnualLeavePlanEdit.vue?vue&type=template&id=0197b284"
import script from "./AnnualLeavePlanEdit.vue?vue&type=script&lang=js"
export * from "./AnnualLeavePlanEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__